export enum FileType {
  Document = 'document',
  Image = 'image',
  Presentation = 'presentation',
  Pdf = 'pdf',
  Spreadsheet = 'spreadsheet',
  Audio = 'audio',
  Video = 'video',
  Zip = 'zip',
  GenericFile = 'genericFile',
}

// The mappings are copied from the web app.
// https://github.com/joinassembly/assembly_frontend/blob/332531ba9e3330252d95e9b75ec51f0e101cd3f8/src/atomic/molecules/FileCard/utils.ts#L29-L115
export function getFileTypeForFile(file: string) {
  switch (file) {
    case 'doc':
    case 'docx':
      return FileType.Document;

    case 'bmp':
    case 'gif':
    case 'jpeg':
    case 'jpg':
    case 'png':
    case 'svg':
      return FileType.Image;

    case 'pps':
    case 'ppsx':
    case 'ppt':
    case 'pptx':
      return FileType.Presentation;

    case 'pdf':
      return FileType.Pdf;

    case 'csv':
    case 'xls':
    case 'xlsx':
      return FileType.Spreadsheet;

    case 'ogg':
    case 'm4a':
    case 'mp3':
    case 'wav':
      return FileType.Audio;

    case '3d2':
    case '3gp':
    case 'avi':
    case 'mov':
    case 'mp4':
    case 'mpg':
    case 'ogv':
      return FileType.Video;

    case 'zip':
      return FileType.Zip;

    default:
      return FileType.GenericFile;
  }
}

export function getFileColorForFileCard(file: string) {
  switch (file) {
    case 'doc':
    case 'docx':
      return 'blue-7';

    case 'bmp':
    case 'gif':
    case 'jpeg':
    case 'jpg':
    case 'png':
    case 'svg':
      return 'primary-8';

    case 'pps':
    case 'ppsx':
    case 'ppt':
    case 'pptx':
      return 'brand-6';

    case 'pdf':
      return 'error-6';

    case 'csv':
    case 'xls':
    case 'xlsx':
      return 'success-7';

    case 'ogg':
    case 'm4a':
    case 'mp3':
    case 'wav':
      return 'warning-6';

    case '3d2':
    case '3gp':
    case 'avi':
    case 'mov':
    case 'mp4':
    case 'mpg':
    case 'ogv':
      return 'error-7';

    case 'zip':
      return 'gray-8';

    default:
      return 'gray-6';
  }
}
